'use strict';

var _ = require('lodash');
var notificationHelpers = require('../common/notifications');
var geolocationHelper = require('../common/geolocation');
var stockInStoreHelper = require('../../stockinstore');
const { isEmpty } = require('lodash');

/**
 * Load Nearest Store locator for the connected customer
 * @param {string} url Get-KML stores url
 */
function loadNearestStoreLocator(url) {
    // Init Nearest Store locator
    const $submitShippingBtn = $('.submit-shipping');
    $submitShippingBtn.hide();
    geolocationHelper.getGeolocation(getCustomerCoordinatesFromAddress).then(function (coords) {
        if (!_.isEmpty(coords)) {
            $('#nearest-store-locator-container').storeLocator({
                lengthUnit: 'km',
                slideMap: false,
                defaultLoc: true,
                shouldReset: true,
                dataType: 'kml',
                dataLocation: url,
                defaultLat: coords.latitude,
                defaultLng: coords.longitude,
                KMLinfowindowTemplate: $('#location-info-window').html(),
                KMLlistTemplate: $('#location-list-description').html(),
                locationList: 'nearest-store-loc-list',
                mapID: 'nearest-store-map',
                ctaButton: '#submitShipmentBtn',
                processKmlLocationDataCallback: getKmlFileData,
                filterLocationsCallback: filterNearestStore,
                afterSuccessCallback: displayNearestStore,
                callbackNotify: function (message) {
                    $('.error-messaging').empty();
                    notificationHelpers.createErrorNotification(message);
                }
            });
            $submitShippingBtn.show();
        }
    }).finally(function () {
        $.spinner().stop();
    });
}

/**
 * Load Nearest Store locator for the connected customer
 * @param {string} url Get-KML stores url
 * @param {JQuery} templates store locator html templates
 */
function loadAllNearestStores(url, templates) {
    // Init All Nearest Stores locator
    var storeListsTemplate = templates.find('.nearest-stores-lists').html();
    var infoWindowTemplate = templates.find('.store-info-window').html();

    geolocationHelper.getGeolocation(getCustomerCoordinatesFromAddress).then(function (coords) {
        if (!_.isEmpty(coords)) {
            $('.stores-locator-container').storeLocator({
                slideMap: false,
                defaultLoc: true,
                maxDistance: true,
                disableNativeListClick: true,
                shouldReset: true,
                findMylocationBtn: 'geolocate-btn',
                isNavigationGeolocationEnabled: coords.isNavigationGeolocEnabled,
                markerImg: $('#mapMarker').val(),
                markerDim: { width: 32, height: 32 },
                maxDistanceID: 'storeRadius',
                addressID: 'searchStores',
                formContainer: 'locate-stores-form-container',
                formID: 'locate-stores-form',
                lengthUnit: 'km',
                dataType: 'kml',
                dataLocation: url,
                defaultLat: coords.latitude,
                defaultLng: coords.longitude,
                locationList: 'all-stores-lists-container',
                mapID: 'stores-map',
                KMLlistTemplate: storeListsTemplate,
                KMLinfowindowTemplate: infoWindowTemplate,
                processKmlLocationDataCallback: getKmlFileData,
                afterSuccessCallback: selectAndFormatAllNearestStores,
                onInfoWindowLoadCallback: displayInfoWindowContent,
                callbackNotify: function (message) {
                    $('.error-messaging').empty();
                    notificationHelpers.createErrorNotification(message);
                }
            });
        }
    }).finally(function () {
        $.spinner().stop();
    });
}

/**
 *@returns {Object} latitude and longitude based on current user address
 */
function getCustomerCoordinatesFromAddress() {
    var $customerAddress = $('#customerAddress');
    var customerInformations = $customerAddress.val() || '{}';
    var address = JSON.parse(customerInformations);
    // Checkout-Begin?stage=customer#customer and the user is not logged in yet
    if (isEmpty(address)) {
        var defaultLatitude = null;
        var defaultLongitude = null;

        if ($customerAddress.length) {
            defaultLatitude = $customerAddress.data('default-latitude');
            defaultLongitude = $customerAddress.data('default-longitude');
        } else {
            var $storeButton = $('.btn-change-store');

            if ($storeButton.length) {
                defaultLatitude = $storeButton.data('default-latitude');
                defaultLongitude = $storeButton.data('default-longitude');
            }
        }

        return new Promise(function (res) {
            return res({
                latitude: defaultLatitude,
                longitude: defaultLongitude
            });
        });
    }

    var fullAddress = address.address1 + ',' + address.postalCode + '/' + address.city;
    const geocoder = new google.maps.Geocoder();

    return new Promise(function (resolve) {
        geocoder.geocode({
            address: fullAddress
        },
        function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
                var geoLocation = _.get(results[0], 'geometry.location', {});

                var coordinates = {
                    latitude: geoLocation.lat(),
                    longitude: geoLocation.lng(),
                    isNavigationGeolocEnabled: false

                };

                return resolve(coordinates);
            }
            // TODO: default to displaying a message/display country or city depending on client output
            return {};
        });
    });
}

/**
 * return JSON data format of the kml file
 * @param {Element} placemark xml tag
 * @returns {Object} location data
 */
function getKmlFileData(placemark) {
    var name = $(placemark).find('name').html();
    var storeID = $(placemark).find('[name=storeID]').children().html();
    var addressOne = $(placemark).find('[name=address1]').children().html();
    var addressTwo = $(placemark).find('[name=address2]').children().html();
    var zipCode = $(placemark).find('[name=postalCode]').children().html();
    var city = $(placemark).find('[name=city]').children().html();
    var openingHours = $(placemark).find('[name=storeHours]').children().html();
    var countryCode = $(placemark).find('[name=countryCode]').children().html();

    // availabilities
    var availableChildcare = $(placemark).find('[name=availableChildcare]').children().html();
    var availableMaternity = $(placemark).find('[name=availableMaternity]').children().html();
    var availableShoe = $(placemark).find('[name=availableShoe]').children().html();
    var availableTextile = $(placemark).find('[name=availableTextile]').children().html();
    var availableToy = $(placemark).find('[name=availableToy]').children().html();
    var kmlCoordinates = $(placemark).find('Point').children().html();
    var coordinates = (kmlCoordinates !== 'undefined' || !kmlCoordinates) ? kmlCoordinates : '';

    var location = {
        name: name,
        storeID: storeID,
        addressOne: addressOne,
        addressTwo: addressTwo,
        postalCode: zipCode,
        city: city,
        openingHours: openingHours,
        countryCode: countryCode,
        lng: Number(_.get(coordinates.split(','), '[0]', '')),
        lat: Number(_.get(coordinates.split(','), '[1]', '')),
        availabilities: {
            availableChildcare: availableChildcare,
            availableMaternity: availableMaternity,
            availableShoe: availableShoe,
            availableTextile: availableTextile,
            availableToy: availableToy
        }
    };

    return location;
}

/**
 *
 * @param {Array} stores a list of all stores
 * @returns {Array} the store with min distance value
 */
function filterNearestStore(stores) {
    var nearestStore = stores.reduce(function (prev, curr) {
        return prev.distance < curr.distance ? prev : curr;
    });

    return [nearestStore];
}

/**
 * @param {Object} storeData array of stringified xml annonation of a given store
 * return nearest store for the connected customer
 */
function displayNearestStore() {
    var nearestStoreTemplate = $('.single-shipping .nearest-store-loc-list');

    var storeData = {
        id: nearestStoreTemplate.find('#storeID').html(),
        name: nearestStoreTemplate.find('#name').html(),
        primaryAddress: nearestStoreTemplate.find('#addressOne').html(),
        secondaryAddress: nearestStoreTemplate.find('#addressTwo').html(),
        postalCode: nearestStoreTemplate.find('#zipCode').html(),
        city: nearestStoreTemplate.find('#city').html(),
        countryCode: nearestStoreTemplate.find('#countryCode').html(),
        openingHours: nearestStoreTemplate.find('#openingHours'),
        availabilities: {
            availableChildcare: nearestStoreTemplate.find('#availableChildcare').html(),
            availableMaternity: nearestStoreTemplate.find('#availableMaternity').html(),
            availableShoe: nearestStoreTemplate.find('#availableShoe').html(),
            availableTextile: nearestStoreTemplate.find('#availableTextile').html(),
            availableToy: nearestStoreTemplate.find('#availableToy').html()
        }
    };

    displaySelectedStore(storeData);

    $('.submit-shipping').show();
    $.spinner().stop();
}

/**
 * Display selected store in DOM
 * @param {Object} storeData store details
 */
function displaySelectedStore(storeData) {
    var $inStores = $('.in-store-shipment');
    var currentStoreId = $('#currentStoreId').val();
    var currentProductId = $('#currentProductId').val();

    // Get stock via controller
    if (currentProductId && (currentStoreId !== 0 || currentStoreId === '')) {
        stockInStoreHelper.getStockInStore(storeData.id, currentProductId, storeData.url);
    } else {
        // Store Address
        $('.selected-store', $inStores).attr('data-id', storeData.id);
        $('.selected-store .name', $inStores).text(storeData.name);
        $('.selected-store .address-one', $inStores).text(storeData.primaryAddress);
        $('.selected-store .address-two', $inStores).text(storeData.secondaryAddress);
        $('.selected-store .zip-code', $inStores).text(storeData.postalCode);
        $('.selected-store .city', $inStores).text(storeData.city);
        $('.selected-store .city-code', $inStores).attr('data-country', storeData.countryCode);
        $('.selected-store .country-code', $inStores).text(storeData.countryCode);

        // Store Availability Icons
        var storesIcons = $('.in-store-icons', $inStores);
        $(storesIcons).empty();
        Object.keys(storeData.availabilities).forEach(function (key) {
            var icon = storeData.availabilities[key].trim();
            if (icon) {
                storesIcons.append('<img class="lazyload" src="' + icon + '" alt="' + [key] + '" title="' + [key] + '" />');
            }
        });

        // Opening hours
        var $openingHours = $('.opening-hours', $inStores);

        if (storeData.openingHours && storeData.openingHours.length > 0) {
            var openingHours = formatOpeningHours(storeData.openingHours);
            var groupByHours = _.groupBy(openingHours, 'hour');
            var openingHoursTemplate = '';
            var openingHoursFormatted = [];

            Object.keys(groupByHours).forEach(function (hour) {
                var days = groupByHours[hour].map(function (h) { return h.day; }).join(' ');
                openingHoursFormatted.push(days + ': ' + hour);
            });

            openingHoursTemplate += openingHoursFormatted.join('. ') + '.';
            $openingHours.removeClass('d-none');
            $openingHours.empty().html(openingHoursTemplate);
        } else {
            $openingHours.addClass('d-none');
        }
    }
}

/**
 * This function rounds distance, sets and displays selected store as shipment address
 * @param {Object} settings store locator plugin settings
 */
function selectAndFormatAllNearestStores(settings) {
    // round distance for stores locations list
    var storeLocationsDistance = $('.store').find('.distance').toArray();
    displayFormattedDistance(storeLocationsDistance, settings);

    // select store when checking radio button
    $('.store input[type="radio"]').on('change', function () {
        var $this = $(this);
        var $li = $this.closest('li');
        var $parent = $this.parent();

        var store = {
            id: $li.find('#storeID').html(),
            name: $li.find('.store-name')
                .html(),
            primaryAddress: $parent.find('.store-address-one').html(),
            secondaryAddress: $parent.find('.store-address-two').html(),
            postalCode: $li.find('#zipCode').html(),
            city: $li.find('#city').html(),
            countryCode: $li.find('#countryCode').html(),
            openingHours: $li.find('#backup-openingHours'),
            url: $(this).data('action'),
            availabilities: {
                availableChildcare: $li.find('#availableChildcare').html(),
                availableMaternity: $li.find('#availableMaternity').html(),
                availableShoe: $li.find('#availableShoe').html(),
                availableTextile: $li.find('#availableTextile').html(),
                availableToy: $li.find('#availableToy').html()
            }
        };
        $('#inStoreLocatorDrawer').modal('hide');
        displaySelectedStore(store);
        $('#shippingMethodRestrictionMessage').remove();
    });

    // select store when clicking on select in map info window description
    $('.modal-body').on('click', '.gm-style-iw-d .select-loc-btn', function (e) {
        e.preventDefault();
        var $mapWindowParent = $(this).closest('.map-window-store');

        var store = {
            id: $mapWindowParent.find('#storeID').html(),
            name: $mapWindowParent.find('.store-name')
                .html(),
            primaryAddress: $mapWindowParent.find('.store-address-one').html(),
            secondaryAddress: $mapWindowParent.find('.store-address-two').html(),
            postalCode: $mapWindowParent.find('#zipCode').html(),
            city: $mapWindowParent.find('#city').html(),
            countryCode: $mapWindowParent.find('#countryCode').html(),
            openingHours: $mapWindowParent.find('#backup-openingHours'),
            availabilities: {
                availableChildcare: $mapWindowParent.find('#availableChildcare').html(),
                availableMaternity: $mapWindowParent.find('#availableMaternity').html(),
                availableShoe: $mapWindowParent.find('#availableShoe').html(),
                availableTextile: $mapWindowParent.find('#availableTextile').html(),
                availableToy: $mapWindowParent.find('#availableToy').html()
            }
        };

        $('#inStoreLocatorDrawer').modal('hide');
        displaySelectedStore(store);
    });

    // format opening hours to "[days that share same opening hours]: opening hours" in stores list
    var openingHoursStoresList = $('ul .store').find('.store-opening-hours').toArray();
    showOpeningHours(openingHoursStoresList);

    $(document).on('hidden.bs.modal', '#inStoreLocatorDrawer', function () {
        $('.stores-list').empty();
        $('.stores-map').empty();
    });
}

/**
 * This function rounds distance, sets and displays selected store as shipment address
 * @param {Object} settings store locator plugin settings
 */
function displayInfoWindowContent(settings) {
    // format opening hours to "[days that share same opening hours]: opening hours" in map
    var $infoWindow = $('.gm-style-iw-d');
    var openingHours = $infoWindow.find('.store-opening-hours').toArray();
    showOpeningHours(openingHours);

    // round distance for map info window
    var distance = $infoWindow.find('.distance').toArray();
    displayFormattedDistance(distance, settings);
}

/**
 * display formatted opening hours in dom
 * @param {jQuery} openingHours dom elements of opening hours of stores
 */
function showOpeningHours(openingHours) {
    if (openingHours.length > 0) {
        openingHours.forEach(function (opening) {
            var $opening = $(opening);
            var parsedOpeningHours = formatOpeningHours($opening);
            var groupByHours = _.groupBy(parsedOpeningHours, 'hour');

            var openingHoursFormatted = [];
            Object.keys(groupByHours).forEach(function (hour) {
                var days = groupByHours[hour].map(function (h) { return h.day; }).join(' ');
                openingHoursFormatted.push(days + ': ' + hour);
            });

            $opening.empty().text(openingHoursFormatted.join('. ') + '.');
        });
    }
}
/**
 * display rounded distance in dom element
 * @param {jQuery} distance dom element of distance
 * @param {Object} settings jquery store locator plugin settings
 */
function displayFormattedDistance(distance, settings) {
    distance.forEach(function (item) {
        var distanceInteger = Number($(item).html());
        var roundDistance = Math.round(distanceInteger);
        $(item).text(roundDistance + settings.lengthUnit);
    });
}

/**
 * Parse encoded HTML and return opening hours in JSON format
 * @param {JQuery} encodedHtmlOpeningHours opening hours jquery selector
 * @returns {Array} of objects of the opening hours in the following format {"day": "opening hours"}
 * */
function formatOpeningHours(encodedHtmlOpeningHours) {
    // using textarea as a safe way to decode html https://stackoverflow.com/a/1395954
    var element = document.createElement('textarea');
    element.innerHTML = encodedHtmlOpeningHours.text();
    var storeHoursStr = element.value;
    var $storeHoursStr = $(storeHoursStr).html();

    if (!$storeHoursStr) {
        return [];
    }

    var formattedOpeningHours = {};

    var storeHoursArray = $storeHoursStr.split('.').filter(function (el) {
        return el !== '';
    });
    for (var index = 0; index < storeHoursArray.length; index += 1) {
        var workingDaysWithHours = storeHoursArray[index].split(':').filter(function (el) {
            return el !== '';
        });
        var days = workingDaysWithHours[0].split(' ').filter(function (el) {
            return el !== '';
        });

        if (workingDaysWithHours.length > 1) {
            for (var idx = 0; idx < days.length; idx += 1) {
                formattedOpeningHours[days[idx]] = workingDaysWithHours[1].replace(';', '').trim();
            }
        }
    }

    var openingHours = Object.keys(formattedOpeningHours).map(function (key) {
        return {
            day: key,
            hour: formattedOpeningHours[key]
        };
    });

    return openingHours;
}

module.exports = {
    methods: {
        loadNearestStoreLocator: loadNearestStoreLocator,
        loadAllNearestStores: loadAllNearestStores
    }
};
